import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { IapClientIdFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 編集モーダル用のIAP Client IDのフォームです。
 */
export const IapClientIdForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <Box pl="40px">
        <FormLabel>- IAP Client ID</FormLabel>
      </Box>
      <IapClientIdFormBase register={register} />
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
